import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {JhiLanguageService} from 'ng-jhipster';
// noinspection TypeScriptPreferShortImport
import {ProfileService} from '../profiles/profile.service'; // FIXME barrel doesnt work here
import {JhiLanguageHelper, Principal} from '../../shared';
import {DEBUG_INFO_ENABLED, VERSION} from '../../app.constants';
import {LoginService} from '../../account';
import {ParametrageService} from '../../entities/parametrage';
import {Response} from '@angular/http';

@Component({
    selector: 'jhi-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: [
        '../../../content/scss/navbar.scss'
    ]
})
export class NavbarComponent implements OnInit {

    inProduction: boolean;
    isNavbarCollapsed: boolean;
    languages: any[];
    swaggerEnabled: boolean;
    modalRef: NgbModalRef;
    version: string;
    username: any;
    isGestionnaire = false;
    isEnseignant = false;
    isReferent = false;
    isUser = false;
    isAdminSys = false;
    isAdmin = false;
    parametrage: any;

    constructor(
        private loginService: LoginService,
        private languageHelper: JhiLanguageHelper,
        private languageService: JhiLanguageService,
        private principal: Principal,
        private parametrageService: ParametrageService,
        private profileService: ProfileService,
        private router: Router
    ) {
        this.version = DEBUG_INFO_ENABLED ? 'v' + VERSION : '';
        this.isNavbarCollapsed = true;
        this.languageService.addLocation('home');
    }

    ngOnInit() {
        this.parametrageService.queryPageAll().subscribe(
            (res: Response) => {
                this.parametrage = this.parametrageService.parametresArrayToObject(res.json());
            });
        this.languageHelper.getAll().then((languages) => {
            this.languages = languages;
        });

        this.profileService.getProfileInfo().subscribe(profileInfo => {
            this.inProduction = profileInfo.inProduction;
            this.swaggerEnabled = profileInfo.swaggerEnabled;
        });
        this.principal.getIdentityName().then(name => {
            this.username = name;
        });
        this.principal.hasAuthority('ROLE_SYSTEM').then(isAdmin => {
            this.isAdminSys = isAdmin;
        });
        this.principal.hasAuthority('ROLE_ADMIN').then(isAdmin => {
            this.isAdmin = isAdmin;
            this.isGestionnaire = isAdmin;
            if (isAdmin === false) {
                this.principal.hasAnyAuthority(['ROLE_GEST']).then(isGest => {
                    this.isGestionnaire = isGest;
                });
            }
        });
        this.principal.hasAuthority('ROLE_REFERENT').then(isReferent => {
            this.isReferent = isReferent;
        });
        this.principal.hasAuthority('ROLE_DELEGATE').then(isEnseignant => {
            this.isEnseignant = isEnseignant;
        });
        this.principal.hasAuthority('ROLE_USER').then(isUser => {
            this.isUser = isUser && !this.isAdmin && !this.isGestionnaire && !this.isAdminSys;
        });
    }

    changeLanguage(languageKey: string) {
      this.languageService.changeLanguage(languageKey);
    }

    collapseNavbar() {
        this.isNavbarCollapsed = true;
    }

    isAuthenticated() {
        let isAuth =  this.principal.isAuthenticated();
        if (!isAuth) {
            this.username = null;
            this.isGestionnaire = false;
            this.isAdminSys = false;
            this.isAdmin = false;
        } else if (this.username == null) {
            this.ngOnInit();
        }
        return isAuth;
    }

    register() {
        this.router.navigate(['/register']);
    }

    login() {
        this.router.navigate(['/login']);
    }

    logout() {
        this.loginService.logout();
        this.collapseNavbar();
        this.username = null;
        this.isGestionnaire = false;
        this.isAdminSys = false;
        this.isAdmin = false;
        this.router.navigate(['']);
    }

    toggleNavbar() {
        this.isNavbarCollapsed = !this.isNavbarCollapsed;
    }

    getImageUrl() {
        return this.isAuthenticated() ? this.principal.getImageUrl() : null;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/layouts/navbar/navbar.component.ts